import type { Role } from "./roles.ts";

export const Features = ["Engagement", "Recognition", "PerformanceReviews", "Goals", "Meetings", "Plans", "OrgChart", "Compensation"] as const;

export type Feature = (typeof Features)[number];

export function isFeature(value: string): value is Feature {
    return Features.some(feature => feature === value);
}

export function hasFeature(feature: Feature): Role {
    return session => {
        if (!session) {
            return false;
        }

        if (session.assignedFeatures === undefined) {
            return true;
        }

        return session.assignedFeatures.includes(feature);
    };
}
